import { Button } from "react-bootstrap";

import React, { useEffect, useState } from "react";
import { FilePondStatus } from "./filePondHelper";
import { useDispatch } from "react-redux";
import { saveDocuments } from "../../store/documents/documentSlice";
import { AppToast } from "../../lib/toast";
import ConformationPopup from "../controls/conformationPopup";
import { ComponentLoader } from "../loader/componentLoader";
import SlbButton from "../controls/button";
import SlbPopUp from "../controls/slbPopUp";
import { getConfiguredLabel } from "../../common/commonHelper";
import { DocumentsPage, filenameMissingErrorMessage, filenameMissingErrorTitle, fileUploadFailed, goToDocs, HomePage, longTimeMsg, metadataErrorMessage, metadataErrorTitle, pleaseWait, saveButton, saveFileButton, saveToasterMessage, saving, timeMsg } from "../../common/labelConstants";
import { createFileObject } from "./uploadHelper";
// import { toast } from "react-toastify";

const _props = {
    fileList: [],
    onSaveSuccess: () => { },
    metadataForm: {},
    allFilesProcessed: false,
    getFileErrors: (file, formErrors) => {
        return {
            isFileNameHasError,
            isFileHasMetadataError
        }
    }
}
export function SaveFilesButton(props = _props) {
    const [isMounted, setIsMounted] = useState(true);
    const dispatch = useDispatch();
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [showProgress, setShowProgress] = useState(false)
    const [isSaveTakingLongerTime, setSaveTakingLongerTime] = useState(false)


    const listenerName = 'FilePond:processfiles';
    useEffect(() => {
        return () => {
            document.removeEventListener(listenerName, save);
            setIsMounted(false)
        }
    }, [])



    function validateBaseNameAndExtFrontend(baseName, ext, opts = {}) {
        const maxLength = Number.isFinite(opts.maxLength) ? opts.maxLength : 180;

        if (typeof baseName !== "string" || baseName.trim().length === 0) {
            return { ok: false, error: "File name is required." };
        }

        const safeBaseName = baseName;

        if (safeBaseName.length > maxLength) {
            return { ok: false, error: `File name exceeds maximum length (${maxLength}).` };
        }

         // No path separators / traversal
        if (
            safeBaseName.includes("/") ||
            safeBaseName.includes("\\")
        ) {
            return { ok: false, error: "Invalid file name." };
        }

        // No trailing dot/space
        if (/[.\s]+$/.test(safeBaseName)) {
            return { ok: false, error: "Trailing spaces or dots in file name are not allowed." };
        }

        // No control chars
        if (/[\x00-\x1F\x7F]/.test(safeBaseName)) {
            return { ok: false, error: "File name contains invalid characters." };
        }

      
        // Prevent filename from already containing an extension
        const suspiciousPrev = new Set([
            "jpg", "jpeg", "png", "gif", "bmp", "tif", "tiff", "svg",
            "pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt",
            "zip", "rar", "7z", "tar", "gz"
        ]);

        const parts = safeBaseName.split(".");
        if (parts.length >= 2) {
            if (parts.some(p => p.length === 0)) {
                return { ok: false, error: "Invalid file name."  };
            }

            const lastToken = parts[parts.length - 1].toLowerCase();
            if (suspiciousPrev.has(lastToken)) {
                return { ok: false, error: "File name must not include an extension." };
            }
        }

        const safeExt = String(ext || "").toLowerCase().trim();
        if (!safeExt) {
            return { ok: false, error: "File extension is required." };
        }

        return { ok: true };
    }


    function save() {
    if (isMounted) {
        // setShowProgress(false);

        const updatedList = props.fileList.map(file => createFileObject(file));
      

        // Frontend save-time filename validation
        for (const item of updatedList) {
           
            const fileNameToValidate = item.updatedFileName || item.originalFileName;
         
            const extToValidate = item.fileExt;
          

            const v = validateBaseNameAndExtFrontend(fileNameToValidate, extToValidate, {
                maxLength: props.config?.allowedMaxCharacterInFileName 
            });
        

            if (!v.ok) {
                setShowProgress(false);
                AppToast.Toast.error({
                    title: getConfiguredLabel(HomePage, fileUploadFailed),
                    message: v.error,
                    delayInMs: 5000
                });
                return;
            }
        }

        setShowProgress(true);
        if (props.allFilesProcessed) {
            document.removeEventListener(listenerName, save);

            setTimeout(() => {
                setSaveTakingLongerTime(true);
            }, 2000);

            dispatch(saveDocuments(updatedList)).then((res) => {
                if (isMounted && res?.payload?.status === 200) {
                    AppToast.Toast.success({
                        title: getConfiguredLabel(DocumentsPage, saveToasterMessage),
                        message: getConfiguredLabel(HomePage, goToDocs)
                    });
                    props.onSaveSuccess();
                    setShowProgress(false);
                    setShowConfirmation(false);
                } else {
                    setShowProgress(false);

                    const apiError =
                        res?.payload?.response?.data?.error ||
                        res?.payload?.error ||
                        "Unable to save file.";

                    AppToast.Toast.error({
                        title: getConfiguredLabel(HomePage, fileUploadFailed),
                        message: apiError,
                        delayInMs: 5000
                    });
                }
            }).catch((err) => {
                setShowProgress(false);
                AppToast.Toast.error({
                    title: getConfiguredLabel(HomePage, fileUploadFailed),
                    message: err?.message || "Unable to save file.", // error 
                    delayInMs: 5000
                });
            });
        } else {
            setShowProgress(false);
            document.addEventListener(listenerName, save);
        }
    }
}

    // function save() {
    //     if (isMounted) {
    //         setShowProgress(true)
    //         const updatedList = props.fileList.map(file => createFileObject(file))

    //         if (props.allFilesProcessed) {
    //             document.removeEventListener(listenerName, save)
    //             //dispatch
    //             setTimeout(() => {
    //                 setSaveTakingLongerTime(true)
    //             }, 2000)
    //             dispatch(saveDocuments(updatedList)).then((res) => {
    //                 if (isMounted && res.payload.status === 200) {
    //                     AppToast.Toast.success({ title: getConfiguredLabel(DocumentsPage, saveToasterMessage), message: getConfiguredLabel(HomePage, goToDocs) })
    //                     props.onSaveSuccess();
    //                     setShowProgress(false)

    //                     setShowConfirmation(false)
    //                 }
    //             })
    //         }
    //         else {
    //             document.addEventListener(listenerName, save);
    //         }
    //     }
    // }
    return <>
        <SlbButton disabled={!props.allFilesProcessed} variant="primary" onClick={(e) => {
            props.metadataForm.handleSubmit(() => {
                setShowProgress(true);
                save()
            }, (e) => {

                const hasMetadataError = props.fileList.find(file => {
                    const fileError = props.getFileErrors(file, e) || {};
                    return fileError.isFileHasMetadataError
                });

                const hasFileNameError = props.fileList.find(file => {
                    const fileError = props.getFileErrors(file, e) || {};
                    return fileError.isFileNameHasError
                });

                if (hasMetadataError) {
                    AppToast.Toast.error({ title: getConfiguredLabel(DocumentsPage, metadataErrorTitle), message: getConfiguredLabel(DocumentsPage, metadataErrorMessage) })
                }
                else if (hasFileNameError) {
                    AppToast.Toast.error({ title: getConfiguredLabel(DocumentsPage, filenameMissingErrorTitle), message: getConfiguredLabel(DocumentsPage, filenameMissingErrorMessage) })
                }
            })();

        }}>{getConfiguredLabel(DocumentsPage, saveFileButton)}</SlbButton>


        <SlbPopUp className="saving_file_modal" hideHeader={true} hideFooter={true} show={showProgress}>
            <div>
                <div className="file_modal_title">{getConfiguredLabel(HomePage, saving)}</div>
                {!isSaveTakingLongerTime ? <div className="file_modal_text">{getConfiguredLabel(HomePage, pleaseWait)}</div>
                    : <div className="save-msg-longtime">
                        <div>{getConfiguredLabel(HomePage, longTimeMsg)}</div>
                        <div>{getConfiguredLabel(HomePage, timeMsg)}</div>
                    </div>}
                <ComponentLoader />
            </div>
        </SlbPopUp>
    </>



}
